<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgment">Acknowledgements</a></p>
<p class="TOC"><a href="#/Introduction">Introduction</a></p>
<p class="TOC1"><a href="#/Part01">P<span class="small">ART</span> I. M<span class="small">OVING INTO THE</span> T<span class="small">RENCHES</span>: T<span class="small">HE</span> Y<span class="small">ANKS</span> G<span class="small">O TO</span> W<span class="small">AR</span></a></p>
<p class="TOC"><a href="#/Chapter01">1. April 1918: The Great German Spring Offensive; The Big Red One “Over the Top”</a></p>
<p class="TOC"><span href="#/Chapter02" title="Link target outside of Sample">2. May 1918: The Red Baron; “Hello Girls”; Cantigny Sector</span></p>
<p class="TOC"><span href="#/Chapter03" title="Link target outside of Sample">3. June 1918: Holding Cantigny; Birth of the Devil Dogs</span></p>
<p class="TOC1"><span href="#/Part02" title="Link target outside of Sample">P<span class="small">ART</span> II. T<span class="small">HE</span> Y<span class="small">ANKS</span> M<span class="small">OVE FROM</span> D<span class="small">EFENSE TO</span> O<span class="small">FFENSE</span></span></p>
<p class="TOC"><span href="#/Chapter04" title="Link target outside of Sample">4. July 1918: Powder River, Let ’Er Buck!; Sowing Seeds of Victory; Rock of the Marne; On to Soissons; Turn of the Tide</span></p>
<p class="TOC"><span href="#/Chapter05" title="Link target outside of Sample">5. August 1918: War at Sea; Battle of Montdidier; Aisne-Marne Offensive</span></p>
<p class="TOC"><span href="#/Chapter06" title="Link target outside of Sample">6. September 1918: The Naval War; Battle of St. Mihiel; Nurses at War; Native and Black Warriors</span></p>
<p class="TOC1"><span href="#/Part03" title="Link target outside of Sample">P<span class="small">ART</span> III. A W<span class="small">AR TO</span> W<span class="small">IN AND AN</span> E<span class="small">LUSIVE</span> P<span class="small">EACE TO</span> B<span class="small">UILD</span></span></p>
<p class="TOC"><span href="#/Chapter07" title="Link target outside of Sample">7. October 1918: Grand Meuse—Argonne Offensive; Lost Battalion; Great Influenza Pandemic</span></p>
<p class="TOC"><span href="#/Chapter08" title="Link target outside of Sample">8. November 1918: The Armistice—End of the Great War; America Celebrates; Prisoners of War Return</span></p>
<p class="TOC"><span href="#/Chapter09" title="Link target outside of Sample">9. Postwar Era: Watch on the Rhine—German Occupation; The Peace Conference; Burying the Dead; An Elusive Peace</span></p>
<p class="TOC1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?755c5f24